import { types } from 'mobx-state-tree';
import { callAgroApi } from '@services/agroapi';
import { Instance } from 'mobx-state-tree';
import { DateTimeType, withDateProcessors } from './DateTimeUtility';
import { BasicOrganization } from './BasicOrganization';
export const Follow = withDateProcessors(types.model('Follow', {
  id: types.identifier,
  follow_method: types.maybeNull(types.string),
  request_from: types.maybeNull(types.string),
  follow_method_id: types.maybeNull(types.string),
  organization_left: types.late(() => BasicOrganization),
  organization_right: types.late(() => BasicOrganization),
  status: types.string,
  datetime: DateTimeType
}).actions(self => ({
  acceptPendingInvite() {
    return callAgroApi<{
      message: string;
    }>(`/follows/${self.id}/accept`, 'POST');
  },
  rejectPendingInvite() {
    return callAgroApi<{
      message: string;
    }>(`/follows/${self.id}/reject`, 'DELETE');
  },
  unfollow() {
    return callAgroApi<{
      message: string;
    }>(`/follows/${self.id}/reject`, 'DELETE');
  }
})));
export type IFollow = Instance<typeof Follow>;